export class ThreatHuntingResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "requestId",
            "baseName": "requestId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "threatHuntingType",
            "baseName": "threatHuntingType",
            "type": "string",
            "format": ""
        },
        {
            "name": "ruleId",
            "baseName": "ruleId",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespace",
            "baseName": "namespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "filePath",
            "baseName": "filePath",
            "type": "string",
            "format": ""
        },
        {
            "name": "severity",
            "baseName": "severity",
            "type": "string",
            "format": ""
        },
        {
            "name": "matchOffset",
            "baseName": "matchOffset",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "matchLength",
            "baseName": "matchLength",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return ThreatHuntingResult.attributeTypeMap;
    }
    constructor() {
    }
}
